export default function getPermissionsLocal() {
    return [
        {
            category: "enrolls",
            categoryDescription: "Записи",
            permissions: [
                {
                    name: "show_journal",
                    description: "Отображение раздела Журнал записей"
                },
                {
                    name: "create_enroll",
                    description: "Создание записей"
                },
                {
                    name: "update_enroll",
                    description: "Редактирование записей"
                },
                {
                    name: "delete_enroll",
                    description: "Удаление записей"
                },
            ]
        },
        {
            category: "clients",
            categoryDescription: "Клиенты",
            permissions: [
                {
                    name: "show_clients",
                    description: "Отображать раздел Клиенты"
                },
                {
                    name: "create_clients",
                    description: "Создание клиентов"
                },
                {
                    name: "update_clients",
                    description: "Редактирование клиентов"
                },
                {
                    name: "delete_clients",
                    description: "Удаление клиентов"
                },
                {
                    name: "download_client",
                    description: "Возможность делать выгрузку клиентов"
                },
                {
                    name: "search_client",
                    description: "Поиск клиентов"
                }
            ]
        },
        {
            category: "staff",
            categoryDescription: "Сотрудники",
            permissions: [
                {
                    name: "show_staff",
                    description: "Отображать раздел Сотрудники"
                },
                {
                    name: "create_staff",
                    description: "Создание сотрудников"
                },
                {
                    name: "update_staff",
                    description: "Редактирование сотрудников"
                },
                {
                    name: "delete_staff",
                    description: "Удаление сотрудников"
                },
            ]
        },
        {
            category: "schedule",
            categoryDescription: "Расписание",
            permissions: [
                {
                    name: "show_schedule",
                    description: "Отображать раздел Расписание"
                },
                {
                    name: "crud_schedule",
                    description: "Редактирование расписания"
                },
            ]
        },
        {
            category: "filial",
            categoryDescription: "Компании/Филиалы",
            permissions: [
                {
                    name: "create_filial",
                    description: "Создание новых компаний"
                },
                {
                    name: "update_filial",
                    description: "Редактирование компаний"
                },
                {
                    name: "delete_filial",
                    description: "Удаление компаний"
                },
            ]
        },
        {
            category: "services",
            categoryDescription: "Услуги",
            permissions: [
                {
                    name: "show_services",
                    description: "Отображать раздел Услуги"
                },
                {
                    name: "create_services",
                    description: "Создание категорий и услуг"
                },
                {
                    name: "update_services",
                    description: "Редактирование категорий и услуг"
                },
                {
                    name: "delete_services",
                    description: "Удаление категорий и услуг"
                },
            ]
        },
        {
            category: "source",
            categoryDescription: "Источники привлечения",
            permissions: [
                {
                    name: "create_source_client",
                    description: "Создание источников привлечения"
                },
                {
                    name: "edit_source_client",
                    description: "Изменение источников привлечения у заявок и клиентов"
                },
                {
                    name: "delete_source_client",
                    description: "Удаление источников привлечения"
                },
            ]
        },
        {
            category: "integrate",
            categoryDescription: "Раздел Запись Онлайн",
            permissions: [
                {
                    name: "show_integrate",
                    description: "Отображать раздел Запись Онлайн"
                },
                {
                    name: "edit_hash_filial",
                    description: "Изменение хэша компании",
                },
                {
                    name: "create_filial_group",
                    description: "Создание группировок компаний",
                },
                {
                    name: "edit_filial_group",
                    description: "Изменение группировок компаний",
                },
                {
                    name: "delete_filial_group",
                    description: "Удаление группировок компаний",
                }
            ]
        },
        {
            category: "other",
            categoryDescription: "Прочее",
            permissions: [
                {
                    name: "show_salary",
                    description: "Просмотр и редактирование раздела Расчет Зарплат"
                },
                {
                    name: "show_stat",
                    description: "Отображение раздела Отчеты"
                },
                {
                    name: "edit_password",
                    description: "Возможность изменять пароль своей учетной записи"
                },
            ]
        },
    ];
};